import { formatSEK } from '@budgie/shared';

/** Whole kronor, e.g. 1234567 öre → "12 346 kr". For overview numbers, not ledgers. */
export const kr = (ore: number) => formatSEK(Math.round(ore / 100) * 100);

/** Whole kronor with an explicit sign for inflows, e.g. "+450 kr" / "−1 200 kr" */
export const signedKr = (ore: number) => (ore > 0 ? `+${kr(ore)}` : kr(ore));
